/**
 * @module experience/shop/product-details
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DeviceDetailsLandingComponent } from './components/device-details-landing/device-details-landing.component';
import { ProductDetailsService } from '../services/product-details.service';
import { AemModule } from '@core/aem/aem.module';
import { SharedBrowseModule } from '@experience/shop/shared-browse/shared-browse.module';
import { RouterModule } from '@angular/router';
import { PRODUCT_DETAILS_ROUTES } from '@experience/shop/product-details/product-details.routes';
import { WidgetsModule } from '@support/shared/widgets/widgets.module';
import { AccessorySectionModule } from '@experience/shop/accessory-section/accessory-section.module';
import { ProductReviewsLandingComponent } from './components/product-reviews-landing/product-reviews-landing.component';

@NgModule({
  imports: [
    CommonModule,
    AemModule,
    FormsModule,
    RouterModule.forChild(PRODUCT_DETAILS_ROUTES),
    SharedBrowseModule,
    AccessorySectionModule,
    WidgetsModule,
  ],
  declarations: [DeviceDetailsLandingComponent, ProductReviewsLandingComponent],
  providers: [ProductDetailsService],
})
export class ProductDetailsModule {}
